import React, { useEffect, useRef } from 'react';
import { ScrollTrigger } from '../gsap';
import '../styles/interactiveLink.scss';
import CategoryIndicator from '../components/CategoryIndicator';
import videomov from '../assets/interativeGloveVideo.mov';
import video from '../assets/interativeGloveVideo.webm';
import poster from '../assets/interativeGlovePoster.png';

const InteractiveLink = () => {
  const videoRef = useRef();
  const interativeRef = useRef();
  useEffect(() => {
    ScrollTrigger.create({
      trigger: interativeRef.current,
      start: 'top center',
      onEnter: () => {
        videoRef.current.play();
      }
    });
  }, []);

  return (
    <div className="interactiveLink" id="interactive" ref={interativeRef}>
      <div className="interactiveLink__videoCont">
        <video
          muted
          playsInline
          loop
          preload="auto"
          ref={videoRef}
          className="interactiveLink__videoCont__video"
          poster={poster}
        >
          <source src={videomov} type="video/quicktime" />
          <source src={video} type="video/webm" />
        </video>
      </div>
      <div className="interactiveLink__textCont">
        <CategoryIndicator origin="interactive" />
        <h4 className="bold">The Evolution of Inclusive Spacesuit Design</h4>
        <p className="small">
          Spacesuits haven’t always been designed for all humankind — but that’s changing. Discover
          how spacesuits have evolved over time to take more people farther.
        </p>
        <div className="interactiveLink__button">
          <a
            className="linkButtons"
            rel="sponsored"
            target="_blank"
            href="https://sponsorcontent.cnn.com/interactive/morganstanley/evolution-of-spacesuit-design/"
          >
            Explore
          </a>
        </div>
      </div>
    </div>
  );
};

export default InteractiveLink;
